<template>
  <LabeledText :label="label">
    <Chip :color="value ? 'green' : 'gray'">
      {{ value ? "Yes" : "No" }}
      <v-icon class="ml-1" color="green" v-if="value">
        mdi-check
      </v-icon>
    </Chip>
  </LabeledText>
</template>

<script>
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import Chip from "@/components/common/Chip";

export default {
  name: "BaseDetails",
  props: {
    value: Boolean,
    label: String
  },
  components: { LabeledText, Chip }
};
</script>

<style scoped lang="scss"></style>
